import React from 'react';
import Transition from 'react-transition-group/Transition';

const duration = 400;

const defaultStyle = {
  height: '100%',
  maxHeight: 0,
  transition: `all ${duration}ms ease-in-out`
};

const transitionStyles = {
  entering: { maxHeight: 0 },
  entered: { maxHeight: '10000px' }
};

export default function SlideToggle({ in: inProp, children }) {
  return (
    <Transition in={inProp} timeout={duration}>
      {state => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
}
